/** Badge d'une feuille d'absence (déclarée par le manager ou le Dirigeant : aucune heure, à ne pas confondre avec « 0h ») */
export function AbsenceBadge() {
  return (
    <span className="text-xs font-normal px-2 py-0.5 rounded-full border bg-violet-50 text-violet-700 border-violet-200">
      Absence
    </span>
  );
}
